import * as React from 'react';

import Typography from '@mui/material/Typography';

import Link from '@mui/material/Link';

import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Hero from './components/hero/Hero';

import Illustrations from './components/sections/illustrations/Illustrations';

import Organizers from './components/sections/organizers/Organizers';
import FAQs from './components/sections/faqs/FAQs';
import Testimonials from './components/sections/testimonials/Testimonials';
import Features from './components/sections/features/Features';
import Section from './components/section/Section';
import GlobalStyle from './components/common/global/GlobalStyle';
import Events from './components/sections/events/Events';


export default function App() {
  return (
    <>
      <GlobalStyle />
      <Header />
      <Hero />
      <Section
        badgeText="Main Features"
        titleText="How Does It work?"
      >
        <Illustrations />
      </Section>
      <Section
        badgeText="Activities"
        titleText="Our Online Activities"
      >
        <Events />
      </Section>

      <Section
        badgeText="Features"
        titleText="What Realverse Can Do"
        reverse={true}
        background='#F1F5FF'

      >
        <Features />
      </Section>
      <Section
        badgeText="Organizers"
        titleText="Share your events around the world"
      >
        <Organizers />
      </Section>

      <Section
        badgeText="Testimonials"
        titleText="What Community Says About Us"
      >
        <Testimonials />
      </Section>
      <Section
        badgeText="Answers For Your Questions"
        titleText="Frequently Asked Questions"
      >
        <FAQs />
      </Section>
      <Footer />
    </>
  );
}
